import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddTaxComponent } from "../admin-add-tax/admin-add-tax.component";
import { AdminTaxEditComponent } from "../admin-tax-edit/admin-tax-edit.component";
import { AdminService } from "../admin.service";
import { Subscription } from "rxjs";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";

@Component({
  selector: "app-admin-tax",
  templateUrl: "./admin-tax.component.html",
  styleUrls: ["./admin-tax.component.css"],
})
export class AdminTaxComponent implements OnInit, OnDestroy {
  matdialogref!: MatDialogRef<AdminTaxEditComponent>;
  matDialogref!: MatDialogRef<AdminAddTaxComponent>;
  token: any;
  taxArray: any = [];
  s9Array: any = [];
  customerArray: any = [];
  driverArray: any = [];
  customerGSTArray: any = [];
  taxDeleteId: string[] = [];
  tripType: string = "s9";
  s9: boolean = true;
  customer: boolean = false;
  driver: boolean = false;
  customerGST: boolean = false;
  taxSelect: boolean = true;
  taxCancel: boolean = false;
  taxDelete: boolean = false;
  selectedType: string = "s9";
  checkBox: boolean = false;
  customerCheckBox: boolean = false;
  driverCheckBox: boolean = false;
  exemptCheckBox: boolean = false;
  SelectedItems: number = 0;
  document_array: any = [];
  fetch_page: number = 1;
  currentPage: number = 1;
  total_cat_count: any;
  startPage: number = 1;
  last_page: number = 1;
  btn1: boolean = true;
  number: any;
  subscription: Subscription | undefined;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  perPage: number = 10;
  page: number = 1;
  searchTaxType: any = -1;
  s9loading: boolean = false;
  customerloading: boolean = false;
  driverloading: boolean = false;
  exmptedloading: boolean = false;
  addBtn: boolean = true;
  clear_Btn: boolean = false;
  search_Btn1: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  @ViewChild("newItem") newItem!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.select(this.tripType);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  resetSelectionState() {
    this.checkBox = false;
    this.customerCheckBox = false;
    this.driverCheckBox = false;
    this.exemptCheckBox = false;
    this.taxDeleteId = [];
    this.SelectedItems = 0;
    this.taxSelect = true;
    this.taxCancel = false;
    this.taxDelete = false;
    this.addBtn = !this.toggleSearch;
    this.searchButton = !this.toggleSearch;
  }

  onInputChange(value: any) {
    const val = value || "";
    const previousLength = this.previousValue.length;
    this.previousValue = val;
    if (
      val.length < previousLength ||
      (val.length > previousLength && this.clear_Btn)
    ) {
      this.search_Btn1 = true;
      this.clear_Btn = false;
    }
    if (val.trim().length >= 1) {
      this.isInputValid = true;
    } else {
      this.isInputValid = false;
    }
    if (val.length === 0) {
      this.resetSearch();
    }
  }

  taxEdit(item: any) {
    this.matdialogref = this.matDialog.open(AdminTaxEditComponent, {
      width: "40vw",
      autoFocus: false,
      data: item,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.getTax(this.searchTaxType);
    });
    if (!this.subscription) {
      this.subscription = this.services.getLRRefreshData().subscribe((value) => {
        this.number = value;
        this.getTax(this.searchTaxType);
      });
    }
  }

  getTripsList(selectedTripType: any) {
    this.select(selectedTripType);
  }

  getTax(type: any) {
    this.searchTaxType = type;

    // Clear arrays before populating to avoid duplicates
    this.s9Array = [];
    this.customerArray = [];
    this.driverArray = [];
    this.customerGSTArray = [];

    // Reset loading state for active tab
    this.s9loading = this.tripType === "s9";
    this.customerloading = this.tripType === "customer";
    this.driverloading = this.tripType === "driver";
    this.exmptedloading = this.tripType === "customerGST";

    // Call API to fetch the tax list
    this.services
      .TaxGet(
        this.token,
        this.tripType,
        this.searchTaxType,
        this.perPage,
        this.page
      )
      .subscribe(
        (response: any) => {
          this.s9loading = false;
          this.customerloading = false;
          this.driverloading = false;
          this.exmptedloading = false;

          if (response?.body?.data?.meta) {
            this.last_page = response.body.data.meta.lastPage || 1;
            this.fetch_page = response.body.data.meta.currentPage || this.page;
            this.currentPage = this.fetch_page;
            this.total_cat_count = response.body.data.meta.total;
            this.document_array = [response.body.data.meta];
          } else {
            this.last_page = 1;
          }

          this.taxArray = response?.body?.data?.data || [];

          // Populate arrays without duplicates
          for (const tax of this.taxArray) {
            switch (tax.tax_user_type) {
              case "s9":
                if (!this.s9Array.some((t: any) => t._id === tax._id)) {
                  this.s9Array.push(tax);
                }
                break;
              case "customer":
                if (!this.customerArray.some((t: any) => t._id === tax._id)) {
                  this.customerArray.push(tax);
                }
                break;
              case "driver":
                if (!this.driverArray.some((t: any) => t._id === tax._id)) {
                  this.driverArray.push(tax);
                }
                break;
              case "customerGST":
                if (!this.customerGSTArray.some((t: any) => t._id === tax._id)) {
                  this.customerGSTArray.push(tax);
                }
                break;
            }
          }
        },
        (error) => {
          this.s9loading = false;
          this.customerloading = false;
          this.driverloading = false;
          this.exmptedloading = false;
          this.taxArray = [];
          this.s9Array = [];
          this.customerArray = [];
          this.driverArray = [];
          this.customerGSTArray = [];
          this.last_page = 1;
          this.document_array = [];

          if (error.status === 404 || error.error?.message === "No records found") return;

          if (
            error.error?.message === "jwt malformed" ||
            error.error?.message === "jwt expired" ||
            error.error?.message === "invalid signature"
          ) {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error?.message || "Failed to load taxes", "Fail", {
            duration: 5000,
          });
        }
      );
  }

  select(type: any) {
    this.tripType = type;
    this.selectedType = type;

    this.resetSelectionState();

    this.page = 1;
    this.fetch_page = 1;
    this.currentPage = 1;

    this.s9 = type === "s9";
    this.customer = type === "customer";
    this.driver = type === "driver";
    this.customerGST = type === "customerGST";

    this.s9loading = this.s9;
    this.customerloading = this.customer;
    this.driverloading = this.driver;
    this.exmptedloading = this.customerGST;

    this.getTax(this.searchTaxType);
  }

  selectTax(type: any) {
    this.taxDeleteId = [];
    this.SelectedItems = 0;
    this.taxSelect = false;
    this.taxCancel = true;
    this.taxDelete = true;
    this.addBtn = false;
    this.searchButton = false;

    this.checkBox = type === "s9";
    this.customerCheckBox = type === "customer";
    this.driverCheckBox = type === "driver";
    this.exemptCheckBox = type === "customerGST";
  }

  cancelTax() {
    this.resetSelectionState();
  }

  addTax(type: any) {
    this.matDialogref = this.matDialog.open(AdminAddTaxComponent, {
      width: "40vw",
      data: { type, dataType: this.tripType },
      autoFocus: false,
    });
    this.matDialogref.afterClosed().subscribe((data) => {
      if (data && data.dataType) {
        this.select(data.dataType);
      } else {
        this.getTax(this.searchTaxType);
      }
    });
  }

  public matItem(event: any, itemId: any) {
    if (event.checked) {
      if (!this.taxDeleteId.includes(itemId)) {
        this.taxDeleteId.push(itemId);
      }
    } else {
      const index = this.taxDeleteId.indexOf(itemId);
      if (index > -1) {
        this.taxDeleteId.splice(index, 1);
      }
    }
    this.SelectedItems = this.taxDeleteId.length;
  }

  public deleteTax() {
    if (this.SelectedItems <= 0 || !this.taxDeleteId || this.taxDeleteId.length === 0) {
      this.snackBar.open("Please select tax to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matDialog.open(CommonHelperComponent, {
        data: {
          message: "Are you sure you want to delete this record?",
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result === "yes") {
          this.services
            .DeleteTax({ ids: this.taxDeleteId }, this.token)
            .subscribe(
              (response: any) => {
                if (response.status === 200 || response.status === 201) {
                  this.snackBar.open("Tax deleted successfully", "Success", {
                    duration: 3000,
                  });
                  this.cancelTax();
                  this.getTax(this.searchTaxType);
                }
              },
              (error) => {
                if (
                  error.error?.message === "jwt malformed" ||
                  error.error?.message === "jwt expired" ||
                  error.error?.message === "invalid signature"
                ) {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                this.snackBar.open(
                  error.error?.message || "Failed to delete tax",
                  "Fail",
                  {
                    duration: 5000,
                  }
                );
              }
            );
        }
      });
    }
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page || 1;

    if (page_status == "-1") {
      newPage = Math.max(1, newPage - 1);
    } else if (page_status == "1") {
      newPage = this.last_page ? Math.min(this.last_page, newPage + 1) : newPage + 1;
    } else if (page_status == "first") {
      newPage = 1;
    } else if (page_status == "last") {
      newPage = this.last_page || 1;
    }

    if (newPage === this.fetch_page && page_status !== "first" && page_status !== "last") {
      return;
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;
    this.page = newPage;

    this.resetSelectionState();
    this.getTax(this.searchTaxType);
  }

  openSearch() {
    this.toggleSearch = true;
    this.search_Btn1 = true;
    this.searchButton = false;
    this.addBtn = false;
    this.clear_Btn = false;
    this.resetSelectionState();
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement?.nativeElement?.focus(), 0);
    }
  }

  search(value: string) {
    const trimmed = (value || "").trim();
    if (trimmed !== "") {
      this.searchTaxType = trimmed;
      this.page = 1;
      this.fetch_page = 1;
      this.currentPage = 1;
      this.resetSelectionState();
      this.getTax(this.searchTaxType);
      this.toggleSearch = true;
      this.clear_Btn = true;
      this.search_Btn1 = false;
      this.searchButton = false;
    }
  }

  resetSearch() {
    this.searchTaxType = -1;
    this.previousValue = "";
    this.toggleSearch = false;
    this.clear_Btn = false;
    this.search_Btn1 = false;
    this.searchButton = true;
    this.addBtn = true;
    this.isInputValid = false;
    this.resetSelectionState();
    this.page = 1;
    this.fetch_page = 1;
    this.currentPage = 1;
    if (this.newItem?.nativeElement) {
      this.newItem.nativeElement.value = "";
    }
    this.getTax(this.searchTaxType);
  }
}
